import { render, staticRenderFns } from "./Actor.vue?vue&type=template&id=667f2d0a&scoped=true"
var script = {}
import style0 from "./Actor.vue?vue&type=style&index=0&id=667f2d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667f2d0a",
  null
  
)

export default component.exports